// extracted by mini-css-extract-plugin
module.exports = {"center":"add-transaction_center__1hKT1","content":"add-transaction_content__1rKNM","user_info_container":"add-transaction_user_info_container__jUyqy"};